import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { postMVP } from "../../api"
import { endGame, toggleTime } from "../../api/socket/functions"
import { forceIsLoading } from "../../redux/actions/actions"
import { getSportsConfig } from "../../utility/constants/sportConfig"


function EndButton({ penaltiesOrEnd }) {
	const dispatch = useDispatch()
	const [isOpen, setIsOpen] = useState(false)
	const hasPenalites = getSportsConfig(localStorage.getItem("sport")).penalties

	const onEndGame = () => {
		setIsOpen(false)
		if (localStorage.getItem("mvp") == localStorage.getItem("original-mvp")) {
			endGame()
		} else if (localStorage.getItem("mvp")) {
			dispatch(forceIsLoading(true))
			postMVP(JSON.parse(localStorage.getItem("mvp"))).then(() => {
				dispatch(forceIsLoading(false))
				endGame()
			})
		} else {
			alert("Nije moguće završiti utakmicu bez da se postavi MVP")
		}
	}

	const createBtn = (text, onClick) => {
		return (
			<Button.Ripple
				key={text}
				color="primary"
				size="lg"
				outline
				onClick={onClick}
			>
				{text}
			</Button.Ripple>
		)
	}

	const onClick = (value) => {
		setIsOpen(false)
		toggleTime({ isPaused: true, penaltiesOrEnd: value })
	}

	const createBtns = () => {
		const toReturn = []
		if (!penaltiesOrEnd && hasPenalites) {
			toReturn.push(
				createBtn("Idi na Penale", () => onClick("penalties")),
				createBtn("Idi na Završni ekran", () => onClick("end"))
			)
		} else if (penaltiesOrEnd === "penalties") {
			toReturn.push(createBtn("Idi na Završni ekran", () => onClick("end")))
		} else {
			toReturn.push(createBtn("Spremi Igru", onEndGame))
		}
		return toReturn
	}

	const btns = createBtns()

	return (
		<>
			<Button.Ripple color="primary" outline onClick={() => setIsOpen(true)}>
				Završi
			</Button.Ripple>
			<Modal
				className="modal-dialog-centered"
				isOpen={isOpen}
				toggle={() => setIsOpen(false)}
			>
				<ModalHeader toggle={() => setIsOpen(false)}>
					Izaberi opciju
				</ModalHeader>
				<ModalBody>
					<p>Birajte opciju</p>

					<div
						style={{
							marginTop: "2em",
							display: "flex",
							flexDirection: "column",
							gap: "1em",
						}}
					>
						{btns}
						<Button
							color="secondary"
							size="lg"
							onClick={() => setIsOpen(false)}
						>
							Odustani
						</Button>
					</div>
				</ModalBody>
				<ModalFooter>
					<p style={{ color: "red" }}>
						{btns.length > 1
							? "Ove opcije se nemogu poništiti"
							: "Ova opcija se nemože poništiti"}
					</p>
				</ModalFooter>
			</Modal>
		</>
	)
}

export default EndButton
